/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Tlm_3Inputs */

const en_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`runtime`)
};

const ar_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيئة التشغيل`)
};

const bn_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`runtime`)
};

const de_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufzeit`)
};

const es_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiempo de ejecución`)
};

const fr_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runtime`)
};

const pt_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tempo de execução`)
};

const zh_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行时`)
};

const tr_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`çalışma zamanı`)
};

const ru_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`время выполнения`)
};

const pl_svc_ai_agent_development_tlm_3 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`czas wykonania`)
};

/**
* | output |
* | --- |
* | "runtime" |
*
* @param {Svc_Ai_Agent_Development_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tlm_3 = /** @type {((inputs?: Svc_Ai_Agent_Development_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tlm_3(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tlm_3(inputs)
	return en_svc_ai_agent_development_tlm_3(inputs)
});
export { svc_ai_agent_development_tlm_3 as "svc_ai-agent-development_tlm_3" }